import { InterventionTypeEnum } from '@generated';
import { Activity, GraduationCap, HandHeart } from 'lucide-react';

export function InterventionTypeIcon({ interventionTypeId, className }: { interventionTypeId: InterventionTypeEnum; className?: string }) {
	switch (interventionTypeId) {
		case InterventionTypeEnum.Assess:
			return <Activity className={className ? className : 'size-5 text-gray-600'} />;
		case InterventionTypeEnum.Instruct:
			return <GraduationCap className={className ? className : 'size-5 text-gray-600'} />;
		case InterventionTypeEnum.Perform:
			return <HandHeart className={className ? className : 'size-5 text-gray-600'} />;
		default:
			return null;
	}
}
